/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/ 
// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
// core components/views for Admin layout
import LDAPage from "views/Dashboard/LDA.js";
import Users from "views/users/users.js";
// core components/views for RTL layout
import TableList from "views/users/users.js";
import TrainLda from "views/TrainLda/TrainLda.js";
import Lebeling from "views/Labeling/Labeling";
var dashboardRoutes = [
  {
    path: "/lda",
    name: "LDA",
    rtlName : "تحلیل موضوعی متن",
    icon: Dashboard,
    component: LDAPage,
    layout: "/dashboard"
  },
  // {
  //   path: "/users",
  //   name: "users",
  //   rtlName: "لیست کاربران",
  //   // icon: Person,
  //   component: Users,
  //   layout: "/dashboard"
  // },
  {
    path: "/labeling",
    name: "labeling",
    rtlName: "برچسب‌گذاری",
    icon: Dashboard,
    component: Lebeling,
    layout: "/dashboard"
  },
  // {
  //   path: "/typography",
  //   name: "Typography",
  //   rtlName: "طباعة",
  //   icon: LibraryBooks,
  //   component: Typography,
  //   layout: "/admin"
  // },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   rtlName: "الرموز",
  //   icon: BubbleChart,
  //   component: Icons,
  //   layout: "/admin"
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   rtlName: "خرائط",
  //   icon: LocationOn,
  //   component: Maps,
  //   layout: "/admin"
  // },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   rtlName: "إخطارات",
  //   icon: Notifications,
  //   component: NotificationsPage,
  //   layout: "/admin"
  // },
  // {
  //   path: "/rtl-page",
  //   name: "RTL Support",
  //   rtlName: "پشتیبانی از راست به چپ",
  //   icon: Language,
  //   component: RTLPage,
  //   layout: "/rtl"
  // },
  // {
  //   path: "/upgrade-to-pro",
  //   name: "Upgrade To PRO",
  //   rtlName: "التطور للاحترافية",
  //   icon: Unarchive,
  //   component: UpgradeToPro,
  //   layout: "/admin"
  // }
];

export default dashboardRoutes;
